const api = require('./config.json');
export const API_URL = api.api_url;

export function CLIENTS_GET(token) {
  return {
    url: API_URL + "/client",
    options: {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    },
  };
}

export function CLIENTS_GET_FILTER(token, text) {
  return {
    url: API_URL + `/client/find/${text}`,
    options: {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    },
  };
}

export function CLIENT_GET(id, token) {
  return {
    url: API_URL + `/client/${id}`,
    options: {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    },
  };
}

export function CLIENTS_GET_PAGE(token, pageNumber) {
  return {
    url: API_URL + `/client?page=${pageNumber}`,
    options: {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    },
  };
}

export function CLIENT_POST(body, token) {
  return {
    url: API_URL + "/client",
    options: {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(body),
    },
  };
}

export function CLIENT_PUT(id, body, token) {
  return {
    url: API_URL + `/client`,
    options: {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(body),
    },
  };
}

export function CLIENT_DELETE(id, token) {
  return {
    url: API_URL + `/client/${id}`,
    options: {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
      },
    },
  };
}
